module.exports = __webpack_public_path__ + "img/slide_sp_2.be0360be.png";